export default "__VITE_ASSET___SG6Td$Y__"